class LinkTree {
  constructor() {
    this.toggle = document.querySelector('[data-link-tree-toggle]');
    this.drawer = document.querySelector('[data-link-tree-drawer]');
    this.overlay = document.querySelector('[data-link-tree-overlay]');
    this.close = document.querySelector('[data-link-tree-close]');
    
    this.init();
  }
  
  init() {
    if (!this.toggle || !this.drawer || !this.overlay) return;
    
    this.toggle.addEventListener('click', () => this.open());
    this.close?.addEventListener('click', () => this.closeDrawer());
    this.overlay.addEventListener('click', () => this.closeDrawer());
    
    // Fechar com ESC
    document.addEventListener('keydown', (e) => {
      if (e.key === 'Escape' && this.drawer.classList.contains('active')) {
        this.closeDrawer();
      }
    });
    
    // Copiar cupom
    this.initCouponCopy();
  }
  
  initCouponCopy() {
    const couponElements = document.querySelectorAll('.link-tree-coupon');
    
    couponElements.forEach(coupon => {
      const link = coupon.closest('.link-tree-link');
      if (!link) return;
      
      const couponCode = coupon.getAttribute('data-coupon-code');
      if (!couponCode) return;
      
      // Ao clicar em qualquer parte do botão, copiar o cupom
      link.addEventListener('click', (e) => {
        // Se clicou diretamente no cupom, já copia
        if (e.target.classList.contains('link-tree-coupon') || e.target.closest('.link-tree-coupon')) {
          e.preventDefault();
          e.stopPropagation();
          this.copyCoupon(couponCode, coupon);
          return;
        }
        
        // Se clicou em outra parte do botão, copia o cupom mas não previne o link
        // (se o link tiver URL, pode seguir depois de copiar)
        if (link.tagName === 'A' && link.href) {
          // Copia o cupom mas permite que o link seja seguido
          this.copyCoupon(couponCode, coupon);
        } else {
          // Se não tem link, previne e só copia
          e.preventDefault();
          this.copyCoupon(couponCode, coupon);
        }
      });
    });
  }
  
  copyCoupon(couponCode, couponElement) {
    // Copiar para clipboard
    if (navigator.clipboard && navigator.clipboard.writeText) {
      navigator.clipboard.writeText(couponCode).then(() => {
        this.showCopied(couponElement);
      }).catch(() => {
        this.fallbackCopy(couponCode, couponElement);
      });
    } else {
      this.fallbackCopy(couponCode, couponElement);
    }
  }
  
  showCopied(coupon) {
    const originalText = coupon.textContent;
    coupon.textContent = 'Copiado!';
    coupon.classList.add('copied');
    
    setTimeout(() => {
      coupon.textContent = originalText;
      coupon.classList.remove('copied');
    }, 2000);
  }
  
  fallbackCopy(couponCode, coupon) {
    const textArea = document.createElement('textarea');
    textArea.value = couponCode;
    textArea.style.position = 'fixed';
    textArea.style.opacity = '0';
    document.body.appendChild(textArea);
    textArea.select();
    
    try {
      document.execCommand('copy');
      this.showCopied(coupon);
    } catch (err) {
      console.error('Erro ao copiar cupom:', err);
    }
    
    document.body.removeChild(textArea);
  }
  
  open() {
    this.drawer.classList.add('active');
    this.overlay.classList.add('active');
    document.body.style.overflow = 'hidden';
  }
  
  closeDrawer() {
    this.drawer.classList.remove('active');
    this.overlay.classList.remove('active');
    document.body.style.overflow = '';
  }
}

document.addEventListener('DOMContentLoaded', () => {
  new LinkTree();
});
